<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Настройки <a v-bind:href=robotsTxtUrl target="_blank">robots.txt</a></div>
      <div class="panel-body">
        <form>
          <div class="row">
            <div class="col-xs-6">
              <div class="form-group">
                <label for="robots">Файл robots.txt</label>
                <input type="file" id="robots">
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-default" @click.prevent="store()">Сохранить</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {api} from './http'

  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        url: config.appUrl,
        loaded: false,
        data: {
          html: ''
        }
      }
    },
    computed: {
      robotsTxtUrl: function () {
        return config.appUrl + '/robots.txt'
      }
    },
    methods: {
      store () {
        var formData = new FormData()
        if (document.querySelector('#robots').files.length) {
          var file1 = document.querySelector('#robots').files[0]
          formData.append('robots', file1)
        }

        api.post('robots/store', formData).then(response => {
          if (response.data.success) {
            this.data = response.data.data
          } else {
            // this.modalError = response.data.message
          }
        })
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slider-text {
    width: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminRobots.vue